import React from "react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";

const PageShell = ({ children }) => (
  <div className="font-sans-clean">
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
);

export default PageShell;
